/*
  src/redux/answers/reducer.js

  Created by Justin Chang on 6/15/2017.
*/

import update from '../update';

import {
  SET_ENGAGEMENT_ANSWER,
  SET_ENGAGEMENT_ANSWER_SENT_TO_API,
  REMOVE_ENGAGEMENT_ANSWERS,
} from './constants';

/*
  Answers are of the form:
    campaignId: {
      engagementId: {
        answer
        campaignId
        engagementId
        engagementOrdinal
        duration // seconds; time to complete engagement
        sentToApi
      }
    }
*/

const answersReducer = (state={}, action) => {
  switch (action.type) {

    case SET_ENGAGEMENT_ANSWER:
      return update(state, {
        $deepMerge: {
          [action.payload.campaignId]: {
            [action.payload.engagementId]: action.payload
          }
        }
      });

    case SET_ENGAGEMENT_ANSWER_SENT_TO_API:
      return update(state, {
        [action.payload.campaignId]: {
          [action.payload.engagementId]: {
            $merge: {
              sentToApi: true
            }
          }
        }
      });

    case REMOVE_ENGAGEMENT_ANSWERS:
      return update(state, {
        $unset: [action.payload] // remove list of keys
      });

    default:
      return state;
  }
}

export default answersReducer;



// WEBPACK FOOTER //
// ./src/redux/answers/reducer.js